import React from 'react';
import moment from 'moment';
import { RefreshButton } from '../../../CommonComponents/RefreshButton/RefreshButton';
import useApi from '../../../_hooks/useApi';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { refreshPrefix } from '../../MoneyGuideProConstants';
import { TabHeaderSkeleton } from './components/TabHeaderSkeleton';

interface Props {
  clientId: string;
  title?: string;
  asOfDate: string | null;
}

export const TabHeader: React.FC<Props> = ({ clientId, title, asOfDate }) => {
  const [refresh, { loading: refreshLoading, errors: refreshErrors }] = useApi(
    urlWithParams('/Consumer/MgpReport/Refresh', { clientId }),
    {
      reduxActionPrefix: refreshPrefix,
    },
  );

  const helperText = asOfDate
    ? `Last Updated: ${moment(asOfDate).format('MM/DD/YYYY [at] hh:mm A')}`
    : 'Last Updated:';

  return (
    <TabHeaderSkeleton title={title}>
      <RefreshButton
        isLoading={refreshLoading}
        errors={refreshErrors}
        helperText={helperText}
        onClick={() => refresh()}
      />
    </TabHeaderSkeleton>
  );
};
